import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { AiConsultantComponent } from 'app/ai-consultant/ai-consultant.component';

@Component({
  standalone: false,
  selector: 'webapp-ai-consultant',
  template: `
    <app-ai-consultant #aiConsultant />
    <div
      flVisibility
      (seen)="openConsultantToggleCallout()"
    ></div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompatAiConsultantComponent {
  @ViewChild('aiConsultant')
  aiConsultantWidget: AiConsultantComponent;

  openConsultantToggleCallout(): void {
    this.aiConsultantWidget.openToggleCallout();
  }
}
